import React, { Suspense } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router";
import { AnimatePresence } from "framer-motion";
import Home from "./pages/Home";
import LoadingSpinner from "./UI/LoadingSpinner";

const Work = React.lazy(() => import("./pages/Work"));
const About = React.lazy(() => import("./pages/About"));
function App() {
  const location = useLocation();
  return (
    <AnimatePresence initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />

        <Route
          path="/work"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Work />
            </Suspense>
          }
        />
        <Route
          path="/about"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <About />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AnimatePresence>
  );
}

export default App;
